import ibans from "./ibans";
import ids from "./ids";
import countries from "./countries";
import countryFlag from "./countries-flag";
import dates from "./date-formats";
import isoCodes from "./iso-codes";
import locales from "./locales";
import prefixes from "./prefixes";
import phones from "./phones";
export default {
  ibans: ibans,
  ids: ids,
  countries: countries,
  countryFlag: countryFlag,
  dates: dates,
  isoCodes: isoCodes,
  locales: locales,
  phones: phones,
  prefixes: prefixes
};